import { useEntitiesServiceEntitiesVehicleBrandsListKey } from '@insurance/api/queries'
import { EntitiesService, Vehicle } from '@insurance/api/requests'
import { InfiniteSelect } from '@shared/components'
import { SelectProps } from 'antd'

type Props = {
  vehicleValue?: Vehicle
} & SelectProps

export const EditVehicleBrandSelect = ({
  vehicleValue: _,
  ...props
}: Props) => {
  return (
    <InfiniteSelect
      apiCall={({ search, pageParam, pageSize }) =>
        EntitiesService.entitiesVehicleBrandsList(
          undefined,
          undefined,
          undefined,
          undefined,
          undefined,
          pageParam,
          pageSize,
          search
        )
      }
      queryKey={[useEntitiesServiceEntitiesVehicleBrandsListKey]}
      getOption={(data) => ({
        value: data?.name
      })}
      {...props}
    />
  )
}
